import { useEffect, useState } from 'react';
import { adminAPI, fmtError } from '@/lib/api';
import { formatMoney } from '@/lib/format';

export default function AdminAffiliatePayouts() {
  const [list, setList] = useState([]);
  const [modal, setModal] = useState(null);
  const [reason, setReason] = useState('');
  const [err, setErr] = useState('');
  const load = () => adminAPI.affiliatePayouts('pending').then(setList);
  useEffect(() => { load(); }, []);
  const approve = async (id) => { await adminAPI.approveAffiliate(id); load(); };
  const markPaid = async (id) => { await adminAPI.markAffiliatePaid(id); load(); };
  const deny = async () => {
    setErr('');
    try { await adminAPI.denyAffiliate(modal.request_id, reason); setModal(null); setReason(''); load(); }
    catch (e) { setErr(fmtError(e)); }
  };
  return (
    <div className="space-y-4">
      <h1 className="font-display text-3xl">Affiliate reward requests</h1>
      {list.length === 0 && <div className="card-tech rounded-lg p-10 text-center text-zinc-500 text-sm">No pending affiliate rewards</div>}
      {list.map(r => (
        <div key={r.request_id} className="card-tech rounded-lg p-5 flex flex-wrap items-start justify-between gap-3" data-testid={`aff-payout-req-${r.request_id}`}>
          <div>
            <div className="label-xs">REQUEST #{r.request_id}</div>
            <div className="font-display text-2xl mt-1">${formatMoney(r.amount)}</div>
            <div className="text-xs text-zinc-500 mt-0.5">{r.user_name} · {r.user_email}</div>
            <div className="text-xs text-zinc-500 mt-1 font-mono">{r.cryptocurrency?.toUpperCase()} · {r.network}</div>
            <div className="text-xs text-zinc-300 mt-1 font-mono break-all">{r.wallet}</div>
          </div>
          <div className="flex gap-2 flex-wrap">
            <button className="btn-primary btn-sm" onClick={() => approve(r.request_id)} data-testid={`aff-approve-${r.request_id}`}>Approve</button>
            <button className="btn-ghost btn-sm" onClick={() => markPaid(r.request_id)} data-testid={`aff-paid-${r.request_id}`}>Mark paid</button>
            <button className="btn-ghost btn-sm text-[#ff3366]" onClick={() => setModal(r)} data-testid={`aff-deny-${r.request_id}`}>Decline</button>
            <button className="btn-ghost btn-sm" onClick={async () => { await adminAPI.resetAffiliate(r.request_id); load(); }} data-testid={`aff-reset-${r.request_id}`}>Reset</button>
          </div>
        </div>
      ))}
      {modal && (
        <div className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4" onClick={() => setModal(null)}>
          <div className="card-tech rounded-lg p-6 max-w-md w-full" onClick={e => e.stopPropagation()}>
            <h3 className="font-display text-2xl">Deny affiliate payout</h3>
            <textarea className="input-tech mt-4" rows={3} placeholder="Reason" value={reason} onChange={e => setReason(e.target.value)} />
            {err && <div className="text-sm text-[#ff3366] mt-2">{err}</div>}
            <div className="flex gap-2 mt-3">
              <button className="btn-primary" onClick={deny} disabled={!reason}>Confirm deny</button>
              <button className="btn-ghost" onClick={() => setModal(null)}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
